import { apiClient } from './client';
import type { LoginResponse } from '@/types/auth';

/** POST /auth/login — credenciales + JWT. */
export async function loginRequest(username: string, password: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/login', { username, password });
  return data;
}

/** POST /auth/google — Google Identity Services ID token + panel JWT. */
export async function googleLoginRequest(credential: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/google', { credential });
  return data;
}
